module.exports = __webpack_public_path__ + "img/live.567033ce.jpeg";